import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import StatusPage from '../components/StatusPage';
import { useSeo } from '../seo';

/** The reasons a payment usually does not complete, as the page always said. */
const REASONS = [
  'You may have closed the payment window',
  'There was an issue with your payment method',
  'You chose to cancel the transaction',
];

const Cancel = () => {
  useSeo({ title: 'Payment cancelled | Crestancia', path: '/cancel', noindex: true });

  return (
  <StatusPage
    tone="warning"
    title="Payment cancelled"
    actions={
      <>
        <Button
          component={RouterLink}
          to="/checkout"
          variant="contained"
          disableElevation
          sx={{ px: 4, py: 1.4, borderRadius: 999, fontWeight: 700, textTransform: 'none' }}
        >
          Try again
        </Button>
        <Button
          component={RouterLink}
          to="/home"
          sx={{ px: 3, py: 1.4, borderRadius: 999, fontWeight: 600, textTransform: 'none' }}
        >
          Return to home
        </Button>
      </>
    }
  >
    <Typography sx={{ mb: 2.5 }}>
      It looks like your payment was cancelled or did not complete. This can happen for various
      reasons:
    </Typography>

    <Stack
      spacing={1.25}
      sx={{
        mb: 2.5,
        px: { xs: 0, sm: 2 },
        py: 2,
        borderRadius: 3,
        textAlign: 'left',
        backgroundColor: 'action.hover',
      }}
    >
      {REASONS.map((reason) => (
        <Stack key={reason} direction="row" spacing={1.5} alignItems="flex-start" sx={{ px: 2 }}>
          <Box
            sx={{
              mt: '9px',
              width: 5,
              height: 5,
              flexShrink: 0,
              borderRadius: '50%',
              backgroundColor: 'text.disabled',
            }}
          />
          <Typography sx={{ fontSize: '0.92rem' }}>{reason}</Typography>
        </Stack>
      ))}
    </Stack>

    <Typography>Please try again or contact our support if you need assistance.</Typography>
    </StatusPage>
  );
};

export default Cancel;
